<template>
    <div class="portal_auth page-container">
        <div class="md md-dialog-fullscreen md-transition-in md-dialog">
            <page-header>
                <h3 slot="title" class="title permission-title" v-show="title">
                    {{title}}
                </h3>
            </page-header>

            <FormError v-if="failedAttempt" :error="error"></FormError>

            <permissions />

            <button-submitter
                    @button-clicked="authorize"
                    :attemptingSubmit="attemptingSubmit"
                    :submitEnabled="submitEnabled"
                    :formSubmit="redirect"
                    :formData="formData"
                    :clickText="clickText"
                    attemptText="Authorizing..."
            >
            </button-submitter>
        </div>
    </div>
</template>

<script>
import AuthService from "../../services/AuthService";
import ButtonSubmitter from '../../components/Generic/ButtonSubmitter'
import FormError from '../../components/Generic/FormError';
import HostNameParser from '../../utils/HostNameParser'
import PermissionsDisplayer from '../../components/Auth/Permissions'
import PageHeader from '../../components/Generic/PageHeader';

export default {
    data() {
        return {
            selectedPortal: {},
            submitEnabled: true,
            attemptingSubmit: false,
            failedAttempt: false,
            error: {}
        }
    },

    components: {
        FormError,
        'button-submitter': ButtonSubmitter,
        'permissions': PermissionsDisplayer,
        'page-header': PageHeader,
    },

    created() {
        this.selectedPortal = {
            name: this.$route.params.portal_name,
            id: this.$route.params.portal_id,
            url: this.$route.params.portal_url
        };
    },

    methods: {
        async authorize() {
            this.attemptingSubmit = true;
            this.error = {};
            this.failedAttempt = false;
            this.submitEnabled = false;

            if (!this.redirect) {
                try {
                    const response = await AuthService.authorizeWithoutRedirect(this.formData);
                    this.$router.push({
                        name: 'credentials',
                        params: {
                            code: response.data.code,
                            clientId: response.data.client_id,
                            clientSecret: response.data.client_secret,
                        }
                    });
                } catch (error) {
                    this.attemptingSubmit = false;
                    this.error = error.response.data;
                    this.failedAttempt = true;
                    this.submitEnabled = true;
                }
            }
        }
    },

    computed: {
        hostName() {
            return HostNameParser(this.$store.state.callback_url);
        },

        clickText() {
            return `Authorize ${this.clientName}`;
        },

        // OAuth client name
        clientName() {
            return this.$store.state.client_name;
        },

        title() {
            return `Allow ${this.clientName} to access ${this.selectedPortal.name}?`;
        },

        // generate form data for HTML form submission to OAuth
        formData() {
            return {
                csrf_token: this.$store.state.csrf_token,
                portal_url: this.selectedPortal.url,
            }
        },

        redirect() {
            return this.$store.state.redirect;
        }
    }
}
</script>

<style scoped>
    .permissions {
        margin-bottom: 6rem;
    }

    .permission-title {
        text-align: left !important;
    }

    .portal_auth {
        text-align: left;
        padding-bottom: 20px;
    }

    .domain-computer {
        display: inline-block;
    }

    .title {
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Portal/PortalAuth.vue